import { Logger } from "@kspay/common-utils";
const loggerInstance = new Logger();
export default loggerInstance;